import { render, staticRenderFns } from "./LdpCauHinh.vue?vue&type=template&id=cd357fdc&scoped=true&"
import script from "./LdpCauHinh.vue?vue&type=script&lang=js&"
export * from "./LdpCauHinh.vue?vue&type=script&lang=js&"
import style0 from "./LdpCauHinh.vue?vue&type=style&index=0&id=cd357fdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd357fdc",
  null
  
)

export default component.exports